import { ascendingCompareFunction, descendingCompareFunction } from "store/global/global.utils";
export const getKnowledgeBaseItemSortedResults = (knowledgeBaseItems, nameSortingDirection, lastUsedSortingDirection) => {
    if (nameSortingDirection === null && lastUsedSortingDirection === null) {
        return knowledgeBaseItems;
    }
    const sortingParameter = nameSortingDirection !== null ? "name" : "lastUsed";
    const sortingDirection = nameSortingDirection !== null ? nameSortingDirection : lastUsedSortingDirection;
    if (sortingParameter === "lastUsed") {
        return [...knowledgeBaseItems].sort((item1, item2) => {
            const a = new Date(item1.lastSavedDate);
            const b = new Date(item2.lastSavedDate);
            return sortingDirection === "asc" ? descendingCompareFunction(a, b) : ascendingCompareFunction(a, b);
        });
    }
    else {
        return [...knowledgeBaseItems].sort((item1, item2) => {
            const a = item1.name.toLowerCase();
            const b = item2.name.toLowerCase();
            return sortingDirection === "asc" ? ascendingCompareFunction(a, b) : descendingCompareFunction(a, b);
        });
    }
};
